import React from 'react';
import { Grid, Container } from '@material-ui/core';
import ContainerSection from '../../components/portal/ContainerSection';
import Calendario from '../../components/portal/Calendario/Calendario';
import { ComunicacaoList } from '../../components/portal/comunicacao/ComunicacaoList';
import PlataformasExternasList from '../../components/portal/plataformasExternas/PlataformasExternasList';
import RecursosList from '../../components/portal/recursos/RecursosList'
import ContainerCalendario from '../../components/portal/Calendario/ContainerCalendario'

const PortalEducat = () => {
  return (
    <Container maxWidth={'lg'} style={{paddingBottom: '80px'}}>
      <Grid container>
        <Grid
          item
          container
          xs={12}
          justifyContent="center"
        >
          <ContainerSection
            title="Eventos"
            subtitle="Eventos relacionados ao dia a dia."
          >
            <ContainerCalendario/>
          </ContainerSection>

          <hr
            style={{
              border: '1px solid #DFDFDF',
              width: '100%',
              margin: '60px 0'
            }}
          />

          <ContainerSection
            title="Recursos"
            subtitle="Recursos diversos a serem utilizados em seus estudos."
          >
            <RecursosList/>
          </ContainerSection>

          <hr
            style={{
              border: '1px solid #DFDFDF',
              width: '100%',
              margin: '60px 0'
            }}
          />

          <ContainerSection
            title="Plataformas Externas"
            subtitle="Recursos externos que apoiam aulas presenciais e atividades remotas."
          >
            <PlataformasExternasList />
          </ContainerSection>

          <hr
            style={{
              border: '1px solid #DFDFDF',
              width: '100%',
              margin: '60px 0'
            }}
          />

          <ContainerSection
            title="Comunicação"
            subtitle="Recursos que apoiam a comunicação entre o professor e o estudante."
          >
            <ComunicacaoList />
          </ContainerSection>
        </Grid>
      </Grid>
    </Container>
  );
};

export default PortalEducat;
